document.addEventListener('DOMContentLoaded', function() {
  
    // HIZLI FİYAT BUTONLARINA TIKLANINCA
    document.addEventListener('click', function(e) {
      if (e.target && e.target.classList.contains('js-quick-price-btn')) {
        e.preventDefault();
        const btn = e.target;
        const min = btn.getAttribute('data-min');
        const max = btn.getAttribute('data-max');
        
        const container = btn.closest('.price-range');
        if (!container) return;
  
        const minInput = container.querySelector('.price-range__input-min');
        const maxInput = container.querySelector('.price-range__input-max');
        const slider = container.querySelector('.price-range__slider');
  
        if (minInput && maxInput) {
          // Kutuları doldur
          minInput.value = min;
          maxInput.value = max;
          
          // Varsa Slider'ı güncelle
          if (slider && slider.noUiSlider) {
            slider.noUiSlider.set([min, max]);
          }
          
          // Temanın "Fiyat seçildi, yukarıya etiket at!" demesi için formu tetikle
          const form = minInput.closest('form');
          if (form) {
            form.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      }
    });
  
    // KUTULARA ELLE RAKAM GİRİLİNCE
    document.addEventListener('change', function(e) {
      if (e.target && e.target.classList.contains('price-range__input')) {
         const container = e.target.closest('.price-range');
         const minInput = container.querySelector('.price-range__input-min');
         const maxInput = container.querySelector('.price-range__input-max');
         const slider = container.querySelector('.price-range__slider');
         
         if (slider && slider.noUiSlider) {
             slider.noUiSlider.set([minInput.value, maxInput.value]);
         }
         
         const form = e.target.closest('form');
         if(form) form.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  
  });

// document.addEventListener("click", function (e) {
//   if (e.target && e.target.classList.contains("js-clear-price-btn")) {
//     e.preventDefault();

//     const container = e.target.closest(".price-range");
//     if (!container) return;

//     const minInput = container.querySelector(".price-range__input-min");
//     const maxInput = container.querySelector(".price-range__input-max");
//     const slider = container.querySelector(".price-range__slider");

//     if (minInput && maxInput) {
//       minInput.value = "";
//       maxInput.value = "";

//       if (slider && slider.noUiSlider) {
//         const absoluteMin = container.getAttribute("data-min");
//         const absoluteMax = container.getAttribute("data-max");
//         slider.noUiSlider.set([absoluteMin, absoluteMax]);
//       }

//       const form = minInput.closest("form");
//       if (form) {
//         form.dispatchEvent(new Event("input", { bubbles: true }));
//       }
//     }
//   }
// });
